import React from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { theme } from './utils/theme'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Section from './utils/section';
import faqs from './utils/FAQsData.json'

function FAQsPage() {
    return (
        <Section title="Frequently Asked Questions">
            <Container maxWidth="md">
                {faqs.map((faq, index) => (
                    <Accordion key={index} sx={{ mb: 2, borderRadius: '15px !important', background: theme.palette.background.paper, backdropFilter: 'blur(10px)', '&:before': { display: 'none' } }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon  style={{color:'#2b394a'}}/>}>
                            <Typography fontWeight="bold">{faq.question}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography color="text.secondary">{faq.answer}</Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Container>
        </Section>
    );
}

export default FAQsPage